export default {
  path: '/addAbility',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'addAbility',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
